// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a294f4e9","455":"85de0844","977":"4a59a75c"}[chunkId] + ".chunk.js";
};